






import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';

@Component({})
export default class SignIn extends Vue {
    private loginWithGoogle() {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider).then((res) => {
            if (res === null || res.user === null) {
                return;
            }
            this.$router.push('/');
        }, (err) => {
            alert(err.message);
        });
    }
}
